<template>
  <div class="content-wrapper">
    <div class="col-12 mb-primary">
      <div class="card card-with-shadow border-0 h-100">
        <div class="card-header p-primary bg-transparent">
          <h5 class="card-title d-inline-block mb-0">{{ $t("job_detail") }}</h5>
          <!-- <div class="float-right">
                        <a href="/buyer/job" class="btn btn-primary btn-sm">Back</a>
                    </div> -->
        </div>
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
          >
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                v-model="inputs.title"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_status" class="col-sm-3 mb-0">
                {{ $t("location") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                v-model="inputs.location"
                :required="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_status" class="col-sm-3 mb-0">
                {{ $t("job_type") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-9"
                type="select"
                :required="true"
                v-model="inputs.job_type"
                :list="jobTypeList"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_status" class="col-sm-3 mb-0">
                {{ $t("published") }}
              </label>
              <app-input
                id="inputs_status"
                class="col-sm-9"
                type="select"
                :required="true"
                v-model="inputs.published"
                :list="publishedList"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="inputs.description"
                :required="true"
              />
            </div>
          </form>
          <form
            ref="form"
            data-url="/crud"
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
          >
            <!-- <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('job_title') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.title"
                                            :required="true"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('description') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.description"
                                            :required="true" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('assignment_structure') }}</label>
                                    <app-input type="text"
                                            v-model="inputs.assignment_structure"
                                            :required="true" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('start_date') }}</label>
                                    <app-input type="date"
                                        v-model="inputs.start_date"
                                        :placeholder="$t('select_valid_date')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('end_date') }}</label>
                                    <app-input type="date"
                                        v-model="inputs.end_date"
                                        :placeholder="$t('select_valid_date')"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('assignment_structure2') }}</label>
                                    <p class="mb-0">File.pdf</p>
                                    <p>File.docs</p>
                                </div>
                            </div>
                        </div> -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("assigned_supplier") }}</label>
                  <table class="table">
                    <tr>
                      <td>1</td>
                      <td>Quality Management</td>
                      <td>Supervisor</td>
                      <td>2021-05-04 07:00</td>
                      <td>2021-05-04 07:00</td>
                      <td>
                        <button class="btn btn-primary btn-sm">view</button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <label>{{ $t("site_list") }}</label>
                <table class="table">
                  <tr>
                    <th>S.No</th>
                    <th>Certificate</th>
                    <th>Type</th>
                    <th>Issue Date</th>
                    <th>Expiry Date</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Quality Management</td>
                    <td>Supervisor</td>
                    <td>2021-05-04 07:00</td>
                    <td>2021-05-04 07:00</td>
                    <td>
                      <a href="site" class="btn btn-primary btn-sm">view</a>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Quality Management</td>
                    <td>Supervisor</td>
                    <td>2021-05-04 07:00</td>
                    <td>2021-05-04 07:00</td>
                    <td>
                      <a href="site" class="btn btn-primary btn-sm">view</a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <company-upload
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { COMPANY_JOB_SHOW } from "../../../../../Config/ApiUrl.js";
import { axiosGet } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      inputs: {},
      jobTypeList: [
        { id: "", value: "Choose One" },
        { id: "On-site", value: "On-site" },
        { id: "Hybrid", value: "Hybrid" },
        { id: "Remote", value: "Remote" },
      ],
      publishedList: [
        { id: "", value: "Choose One" },
        { id: "1", value: "Published" },
        { id: "0", value: "Diraft" },
      ],
    };
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },

    getJob(id) {
      axiosGet(COMPANY_JOB_SHOW + "/" + id)
        .then((res) => {
          this.inputs = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    let myLocation = location.href;
    let split = myLocation.split("/");
    let nSplit = split[6].split("?");
    this.getJob(nSplit[0]);
  },
};
</script>
